import type { ApiFetchHomeSectionsPort } from '~/handlers/ports/api-fetch-home-sections.port';
import { getApostatudoApiUrl } from '~/utils/apostatudo/get-apostatudo-api-url';

export class ApostatudoApiFetchHomeSectionsAdapter
  implements ApiFetchHomeSectionsPort
{
  async handle(): Promise<HomeSectionData | HomeSection> {
    const response = await fetch(
      `${getApostatudoApiUrl()}/games/sections/home_cache`,
      {
        method: 'GET',
        cache: 'no-store',
        headers: {
          Accept: 'application/json',
        },
      },
    );

    if (!response.ok) {
      throw new Error(
        `[ApiFetchHomeSections] API returned ${response.status}: ${response.statusText}`,
      );
    }

    const result: HomeSectionApiResponse = await response.json();

    return result.data;
  }
}
